import {Injectable, Injector} from '@angular/core';
import {EntityCollectionServiceElementsFactory} from '@ngrx/data';
import {AbstractRepositoryV2} from "../../../../../../../../core/service/v2/abstractRepositoryV2";
import {TreatmentJourneyDefinitionModel} from "../../../api/entity/treatmentJourneyDefinition.model";

@Injectable({
    providedIn: 'root'
})
export class TreatmentJourneyDefinitionRepository extends AbstractRepositoryV2<TreatmentJourneyDefinitionModel> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, injector: Injector) {
        super('TreatmentJourneyDefinition', serviceElementsFactory, injector);
    }
}
